/**
 * @registry Characters requiring URL-encoding substitution before appending a JWT query param.
 */
export const urlCharacterSubstitions = [
  {
    char: '[',
    replacement: '%5B',
  },
  {
    char: ']',
    replacement: '%5D',
  },
];
// Dev only: backend emits absolute file URLs on its own host, which LAN devices
// cannot reach; route them through the same-origin Vite /api proxy instead.
const toProxiedUrl = (url: string): string => {
  if (!import.meta.env.DEV) return url;
  try {
    const parsed = new URL(url);
    if (parsed.hostname === 'localhost' && parsed.host !== window.location.host) {
      const prefix = parsed.port === '9000' ? '/minio-proxy' : '/api';
      return `${prefix}${parsed.pathname}${parsed.search}`;
    }
  } catch {
    return url;
  }
  return url;
};
/**
 * @registry Encodes special characters in a URL and appends the access token as a `jwt` query param.
 */
export const getUrlWithEncodingAndAuth = (url: string, token?: string) => {
  let clean = toProxiedUrl(url);
  urlCharacterSubstitions.forEach(sub => {
    while (clean.indexOf(sub.char) >= 0) {
      clean = clean.replace(sub.char, sub.replacement);
    }
  });
  return `${clean}?jwt=${token}`;
};
